!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.uk = t());
}(this, function () {
  "use strict";

  return [{
    locale: "uk",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var a = String(e).split("."),
          r = a[0],
          o = !a[1],
          n = Number(a[0]) == e,
          i = n && a[0].slice(-1),
          m = n && a[0].slice(-2),
          l = r.slice(-1),
          f = r.slice(-2);
      return t ? 3 == i && 13 != m ? "few" : "other" : o && 1 == l && 11 != f ? "one" : o && l >= 2 && l <= 4 && (f < 12 || f > 14) ? "few" : o && 0 == l || o && l >= 5 && l <= 9 || o && f >= 11 && f <= 14 ? "many" : "other";
    },
    fields: {
      year: {
        displayName: "рік",
        relative: {
          0: "цього року",
          1: "наступного року",
          "-1": "торік"
        },
        relativeTime: {
          future: {
            one: "через {0} рік",
            few: "через {0} роки",
            many: "через {0} років",
            other: "через {0} року"
          },
          past: {
            one: "{0} рік тому",
            few: "{0} роки тому",
            many: "{0} років тому",
            other: "{0} року тому"
          }
        }
      },
      "year-short": {
        displayName: "р.",
        relative: {
          0: "цього року",
          1: "наступного року",
          "-1": "торік"
        },
        relativeTime: {
          future: {
            one: "через {0} р.",
            few: "через {0} р.",
            many: "через {0} р.",
            other: "через {0} р."
          },
          past: {
            one: "{0} р. тому",
            few: "{0} р. тому",
            many: "{0} р. тому",
            other: "{0} р. тому"
          }
        }
      },
      month: {
        displayName: "місяць",
        relative: {
          0: "цього місяця",
          1: "наступного місяця",
          "-1": "минулого місяця"
        },
        relativeTime: {
          future: {
            one: "через {0} місяць",
            few: "через {0} місяці",
            many: "через {0} місяців",
            other: "через {0} місяця"
          },
          past: {
            one: "{0} місяць тому",
            few: "{0} місяці тому",
            many: "{0} місяців тому",
            other: "{0} місяця тому"
          }
        }
      },
      "month-short": {
        displayName: "міс.",
        relative: {
          0: "цього місяця",
          1: "наступного місяця",
          "-1": "минулого місяця"
        },
        relativeTime: {
          future: {
            one: "через {0} міс.",
            few: "через {0} міс.",
            many: "через {0} міс.",
            other: "через {0} міс."
          },
          past: {
            one: "{0} міс. тому",
            few: "{0} міс. тому",
            many: "{0} міс. тому",
            other: "{0} міс. тому"
          }
        }
      },
      day: {
        displayName: "день",
        relative: {
          0: "сьогодні",
          1: "завтра",
          2: "післязавтра",
          "-2": "позавчора",
          "-1": "учора"
        },
        relativeTime: {
          future: {
            one: "через {0} день",
            few: "через {0} дні",
            many: "через {0} днів",
            other: "через {0} дня"
          },
          past: {
            one: "{0} день тому",
            few: "{0} дні тому",
            many: "{0} днів тому",
            other: "{0} дня тому"
          }
        }
      },
      "day-short": {
        displayName: "д.",
        relative: {
          0: "сьогодні",
          1: "завтра",
          2: "післязавтра",
          "-2": "позавчора",
          "-1": "учора"
        },
        relativeTime: {
          future: {
            one: "через {0} дн.",
            few: "через {0} дн.",
            many: "через {0} дн.",
            other: "через {0} дн."
          },
          past: {
            one: "{0} дн. тому",
            few: "{0} дн. тому",
            many: "{0} дн. тому",
            other: "{0} дн. тому"
          }
        }
      },
      hour: {
        displayName: "година",
        relative: {
          0: "цієї години"
        },
        relativeTime: {
          future: {
            one: "через {0} годину",
            few: "через {0} години",
            many: "через {0} годин",
            other: "через {0} години"
          },
          past: {
            one: "{0} годину тому",
            few: "{0} години тому",
            many: "{0} годин тому",
            other: "{0} години тому"
          }
        }
      },
      "hour-short": {
        displayName: "год.",
        relative: {
          0: "цієї години"
        },
        relativeTime: {
          future: {
            one: "через {0} год",
            few: "через {0} год",
            many: "через {0} год",
            other: "через {0} год"
          },
          past: {
            one: "{0} год тому",
            few: "{0} год тому",
            many: "{0} год тому",
            other: "{0} год тому"
          }
        }
      },
      minute: {
        displayName: "хвилина",
        relative: {
          0: "цієї хвилини"
        },
        relativeTime: {
          future: {
            one: "через {0} хвилину",
            few: "через {0} хвилини",
            many: "через {0} хвилин",
            other: "через {0} хвилини"
          },
          past: {
            one: "{0} хвилину тому",
            few: "{0} хвилини тому",
            many: "{0} хвилин тому",
            other: "{0} хвилини тому"
          }
        }
      },
      "minute-short": {
        displayName: "хв.",
        relative: {
          0: "цієї хвилини"
        },
        relativeTime: {
          future: {
            one: "через {0} хв",
            few: "через {0} хв",
            many: "через {0} хв",
            other: "через {0} хв"
          },
          past: {
            one: "{0} хв тому",
            few: "{0} хв тому",
            many: "{0} хв тому",
            other: "{0} хв тому"
          }
        }
      },
      second: {
        displayName: "секунда",
        relative: {
          0: "зараз"
        },
        relativeTime: {
          future: {
            one: "через {0} секунду",
            few: "через {0} секунди",
            many: "через {0} секунд",
            other: "через {0} секунди"
          },
          past: {
            one: "{0} секунду тому",
            few: "{0} секунди тому",
            many: "{0} секунд тому",
            other: "{0} секунди тому"
          }
        }
      },
      "second-short": {
        displayName: "с",
        relative: {
          0: "зараз"
        },
        relativeTime: {
          future: {
            one: "через {0} с",
            few: "через {0} с",
            many: "через {0} с",
            other: "через {0} с"
          },
          past: {
            one: "{0} с тому",
            few: "{0} с тому",
            many: "{0} с тому",
            other: "{0} с тому"
          }
        }
      }
    }
  }];
});